/**
 * Machine key sent as the `machineKey` request header and inside the login body.
 *
 * The Portal treats a machine key whose MachineName contains "WebAssembly" as a
 * first-party browser client (see Server/Portal/Areas/SuiteAPI/Controllers/UserController.cs
 * and Utils/SuiteAPI/APIService.cs). MDenture is a browser SPA in the same family
 * as Dental.WebManager and SpectraX, so it reuses the exact browser-client machine
 * key shape rather than inventing a new one. This keeps web-client handling on the
 * existing, intended code path.
 */
export const WEB_CLIENT_MACHINE_KEY = JSON.stringify({
  HardwareID: { '21': [2021] },
  MachineName: 'WebAssembly',
  SystemID: '0xDE1DBFEF',
});
